export default {
      id: "service-booklet-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#service-booklet",
      toString: function () {
        return this.url;
      }
    }